import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';

/**
 * Custom hook for managing invoice limit cache state
 * 統一管理發票數量限制快取狀態，避免按鈕閃爍問題
 */
export const useInvoiceLimitCache = () => {
  const userContext = useContext(UserContext);
  const { user } = userContext!;

  // 發票數量限制狀態 - 從快取初始化避免閃爍
  const [canAddInvoice, setCanAddInvoice] = useState(() => {
    if (!user?.id) return true;
    try {
      const cached = localStorage.getItem(`invoice-limit-${user.id}`);
      if (cached) {
        const limitInfo = JSON.parse(cached);
        return limitInfo.isWithinLimit;
      }
    } catch {
      // 快取讀取失敗，使用預設值
    }
    return true;
  });

  // InvoiceLimitBanner 刷新觸發器
  const [limitBannerRefreshTrigger, setLimitBannerRefreshTrigger] = useState(0);

  return {
    canAddInvoice,
    setCanAddInvoice,
    limitBannerRefreshTrigger,
    setLimitBannerRefreshTrigger,
  };
};